/**
 * LO QUE VE EL CLIENTE CON LA APP CERRADA (14-09).
 *
 * El servidor contesta 503 con su frase (`backend/core/puerta.py`) y esto la pinta a
 * pantalla completa. Sin botones que no llevan a ningún sitio, sin «reintentar» que va a
 * fallar igual, y sin una palabra técnica.
 *
 * No cierra la sesión: quien tenía la app abierta la recupera tal cual en cuanto se
 * vuelve a abrir la puerta, sin escribir la contraseña otra vez.
 */
import React from 'react';

export const MENSAJE_POR_DEFECTO =
    'Estamos haciendo unos ajustes en la aplicación. Te avisamos en cuanto vuelva a '
    + 'estar disponible. Tu plan y tus datos están como los dejaste.';

export default function PuertaCerrada({ mensaje }) {
    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-page px-6">
            <div className="w-full max-w-sm text-center">
                <p className="font-heading text-3xl uppercase tracking-wide text-ink">
                    Volvemos pronto
                </p>
                <p className="mt-4 text-[15px] leading-relaxed text-ink/70">
                    {mensaje || MENSAJE_POR_DEFECTO}
                </p>
                <p className="mt-8 text-xs uppercase tracking-[0.2em] text-ink/35">
                    12EN12
                </p>
            </div>
        </div>
    );
}
